/**
 * 구독·정산 — 명세서 §5.21 / §4 구독 게이트
 */
export const SUBSCRIPTION_STATUS = {
    /** 시설 승인 시 자동 부여 (기본 2주, §14.1-17) */
    TRIAL: 'TRIAL',
    ACTIVE: 'ACTIVE',
    /** 유예 — 읽기 전용 (기본 14일) */
    GRACE: 'GRACE',
    /** 만료 — 신규 작성 차단, 기존 기록 열람은 유지 */
    EXPIRED: 'EXPIRED',
};
export const SUBSCRIPTION_STATUS_LABELS = {
    TRIAL: '체험 중',
    ACTIVE: '이용 중',
    GRACE: '유예 기간',
    EXPIRED: '만료',
};
export const SUBSCRIPTION_DEFAULTS = {
    trialDays: 14,
    graceDays: 14,
    expiryNoticeDaysBefore: [30, 7],
};
/**
 * §4 구독 게이트 — 쓰기 권한 판정.
 * EXPIRED·GRACE여도 **읽기는 항상 허용**한다(아동 기록 접근권 보호).
 */
export function canWrite(status) {
    return status === SUBSCRIPTION_STATUS.TRIAL || status === SUBSCRIPTION_STATUS.ACTIVE;
}
export function canRead(_status) {
    return true;
}
/** 시설 개설 신청 상태 (§5.2) */
export const FACILITY_STATUS = {
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    SUSPENDED: 'SUSPENDED',
};
/** 정산 문서 유형 (§5.21) */
export const BILLING_DOCUMENT_TYPES = {
    QUOTE: 'QUOTE',
    STATEMENT: 'STATEMENT',
};
export const BILLING_DOCUMENT_LABELS = {
    QUOTE: '견적서',
    STATEMENT: '거래명세서',
};
/** 세금계산서는 홈택스 등 외부 발행 = 시스템 범위 외 (§14.1-18) */
export const BILLING_TAX_NOTICE = '세금계산서는 본 시스템에서 발행하지 않으며, 홈택스 등 외부 시스템을 통해 별도 발행됩니다.';
export function calcAnnualFee(plan, childCount) {
    const tier = plan.tiers.find((t) => childCount >= t.fromCount && (t.toCount === null || childCount <= t.toCount));
    return plan.baseFee + (tier?.additionalFee ?? 0);
}
//# sourceMappingURL=subscription.js.map